module.exports = __webpack_public_path__ + "resources/img/img_appen_data2_m.0985e5441d0dd42cf9eec052effb5944.png";